<template>
  <div class="w-full d-flex flex-column pa-3">
    <OAlert class="w-full" info v-if="value.isRoot">
      Este perfil é root, portanto pode ver todos os motoristas.
    </OAlert>

    <ACLDisplay :value="value.drivers" strings="motorista;o">
      <template v-slot:isEmpty>
        <OAlert class="w-full" warning>
          Não existem regras. Este perfil não poderá ver nenhum motorista.
        </OAlert>
      </template>
    </ACLDisplay>

    <OCapCont class="w-full pa-3 mt-8" label="Grupo padrão">
      <div>
        {{ (value.drivers && value.drivers.stickyTags) || '─' }}
      </div>
      <span class="caption grey--text">
        (Motoristas editados por este perfil sempre farão parte deste grupo.)
      </span>
    </OCapCont>

    <div class="pa-3 mt-8">
      <v-btn large color="primary" @click="edit">Editar</v-btn>
    </div>

    <ODialog ref="dialog">
      <v-card>
        <ODialogBar title="Motoristas Visíveis" @close="dismiss" />
        <v-card-text class="d-flex flex-wrap pa-3">
          <ACLEditor
            class="pa-3"
            :value="clonedValues"
            strings="motorista;o"
            :allTags="allTags"
          />

          <OSelect
            class="pa-3 w-1/2"
            label="Grupo padrão"
            v-model="clonedValues.stickyTags"
            :items="allDriverGroups"
          />
        </v-card-text>
        <ODialogButtons
          class="pa-6"
          @apply="apply"
          @cancel="dismiss"
          txtApply="Salvar"
        />
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import { OrgApi } from '@/models/index.js'
import ACLDisplay from 'oderon-vue/cpts/acl/ACLDisplay.vue'
import ACLEditor from 'oderon-vue/cpts/acl/ACLEditor.vue'
import utils from 'oderon-commons/src/utils.js'

export default {
  components: {
    ACLDisplay,
    ACLEditor
  },
  props: {
    value: { required: true }
  },
  data() {
    return { allTags: [], allDriverGroups: [], clonedValues: {} }
  },
  methods: {
    async edit() {
      this.clonedValues = JSON.parse(JSON.stringify(this.value.drivers || {}))
      let fetcher = new OrgApi(this.value.orgId)
      this.allTags = utils.sortTags(await fetcher.get('drivers/tags'))
      this.allDriverGroups = (await fetcher.get('drivers/groups')).map((x) => {
        return { value: x.code, text: x.code }
      })

      await this.$refs.dialog.$open()
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    apply() {
      this.dismiss()
      this.$rootLoading(async () => {
        let fetcher = new OrgApi(this.value.orgId)
        let old = await fetcher.get(`profiles/${this.value.id}`)
        old.drivers = this.clonedValues
        await fetcher.put(`profiles/${this.value.id}`, old)
        this.$snack('Salvo com sucesso')
        this.$emit('reload')
      })
    }
  }
}
</script>
